import ApiClient from './ApiClient';

class DashboardStatsAPI extends ApiClient {
  constructor() {
    super('dashboard_stats', { accountScoped: true });
  }
}

export default new DashboardStatsAPI();
